import { XMarkIcon } from '../Icons';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { Box } from '../Box';
import { idBuilder } from '../internal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const smallTitleStyle = theme => ({
  fontSize: theme.tokens.ComponentModalTitleSmallFontSize,
  fontWeight: theme.tokens.ComponentModalTitleSmallFontWeight,
  lineHeight: theme.tokens.ComponentModalTitleSmallLineHeight,
  fontFamily: theme.tokens.ComponentModalTitleSmallFontFamily,
  color: theme.tokens.ComponentModalTitleColor
});
const largeTitleStyle = theme => ({
  fontSize: theme.tokens.ComponentModalTitleLargeFontSize,
  fontWeight: theme.tokens.ComponentModalTitleLargeFontWeight,
  lineHeight: theme.tokens.ComponentModalTitleLargeLineHeight,
  fontFamily: theme.tokens.ComponentModalTitleLargeFontFamily,
  color: theme.tokens.ComponentModalTitleColor
});
const largeOnXSTitleStyle = theme => ({
  fontSize: theme.tokens.ComponentModalTitleLargeOnXsFontSize,
  fontWeight: theme.tokens.ComponentModalTitleLargeOnXsFontWeight,
  lineHeight: theme.tokens.ComponentModalTitleLargeOnXsLineHeight,
  fontFamily: theme.tokens.ComponentModalTitleLargeOnXsFontFamily,
  color: theme.tokens.ComponentModalTitleColor
});
const resolveTitle = function (theme, children, size, id, dataTestId) {
  let customIdentifiers = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  const titleStyleMap = (theme, size) => {
    const _map = {
      small: smallTitleStyle(theme),
      large: largeTitleStyle(theme),
      largeOnXS: largeOnXSTitleStyle(theme),
      fullScreen: largeTitleStyle(theme)
    };
    return _map[size];
  };
  if (typeof children === 'string') {
    return /*#__PURE__*/_jsx(Box, {
      sx: titleStyleMap(theme, size),
      className: 'interstate-modal-title',
      "data-testid": customIdentifiers['titleText']?.dataTestId || idBuilder('ids-modal-title', dataTestId),
      id: customIdentifiers['titleText']?.id || idBuilder('ids-modal-title', id),
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
const titlePaddingMap = {
  small: '16px 24px 20px 24px',
  large: '20px 24px 16px 32px',
  largeOnXS: '20px 8px 16px 16px',
  fullScreen: '20px 24px 16px 32px'
};
const styledDialogTitle = (size, theme) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: titlePaddingMap[size],
  gap: '32px',
  borderTop: size === 'largeOnXS' ? `1px solid ${theme.tokens.ComponentModalBorderColor}` : 'none'
});
export const ModalTitle = _ref => {
  let {
    children,
    onClose,
    id,
    displayCloseButton,
    size,
    customIdentifiers = {},
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const effectiveTitle = resolveTitle(theme, children, size, id, rest['data-testid'], customIdentifiers);
  return /*#__PURE__*/_jsxs(Box, {
    sx: styledDialogTitle(size, theme),
    className: 'ids-modal-title',
    "data-testid": customIdentifiers['title']?.dataTestId || idBuilder('ids-modal-title', rest['data-testid']),
    id: customIdentifiers['title']?.id || idBuilder('ids-modal-title', id),
    children: [effectiveTitle, displayCloseButton ? /*#__PURE__*/_jsx(Box, {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minWidth: '32px',
      minHeight: '32px',
      onClick: onClose,
      className: 'ids-modal-title-close-button',
      id: customIdentifiers['closeButton']?.id || idBuilder('ids-modal-close-button', id),
      "data-testid": customIdentifiers['closeButton']?.dataTestId || idBuilder('ids-modal-close-button', rest['data-testid']),
      children: /*#__PURE__*/_jsx(XMarkIcon, {
        fontSize: '20px',
        color: theme.tokens.SemColorOnSurfaceSubdued
      })
    }) : null]
  });
};